import {AxiosInstance, AxiosResponse} from "axios";

/**
 * A secured file with the headers it came with.
 */
export interface SecureFile {
    blob: Blob;
    headers: Record<string, string | undefined>;
}

/**
 * The document resource.
 *
 * @param {Object} client - The injected client.
 * @returns {Object} The public object.
 */
export default function (client: AxiosInstance) {
    const fetch = (url: string): Promise<AxiosResponse<Blob>> => {
        url = url.replace(import.meta.env.VITE_HDS_URL, '');

        return client.get(url, { responseType: 'blob', validateStatus:null })
            .then(response => {
                if (response.status !== 200) {
                    return Promise.reject(response);
                }

                return response;
            });
    };

    return {
        get (url: string): Promise<Blob> {
            return fetch(url).then(response => response.data);
        },

        /**
         * Get a file along with its response headers, e.g. the page count the
         * HDS sends with a prescription's large thumbnail.
         */
        getWithHeaders (url: string): Promise<SecureFile> {
            return fetch(url).then(response => ({
                blob: response.data,
                headers: response.headers as Record<string, string | undefined>
            }));
        }
    };
}
